import axios from 'axios';

const axiosInstance = axios.create({ 
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL, 
  headers: {},
});
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || null;
    if (token) {
      config.headers.authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default axiosInstance;
